export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00682.62899fd6.png";